import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "vertical-chart-column" }
const _hoisted_2 = { class: "vertical-chart-column__chart" }
const _hoisted_3 = {
  key: 1,
  class: "vertical-chart-column__column-and-line"
}
const _hoisted_4 = {
  key: 0,
  class: "vertical-chart-column__loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EChartsVerticalBar = _resolveComponent("EChartsVerticalBar")!
  const _component_EChartsColumnAndLine = _resolveComponent("EChartsColumnAndLine")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.getHasLinesConfig)
        ? (_openBlock(), _createBlock(_component_EChartsVerticalBar, {
            key: 0,
            labels: _ctx.getCategoryLabels,
            tooltipLabels: _ctx.getTooltipLabels,
            dataset: _ctx.getVerticalBarDataset,
            stack: _ctx.overlapColumns,
            stackTooltipCumulative: _ctx.overlapColumns,
            legendInverseOrder: _ctx.inverseOrderLegend,
            tooltipInverseOrder: _ctx.inverseOrderTooltip,
            showSeriesLabel: false,
            barMaxWidth: 80,
            height: _ctx.height,
            formatLabelFunction: _ctx.getFormatLabelFunction,
            formatValueFunction: _ctx.getFormatValueFunction,
            emptyMessage: _ctx.getEmptyMessage
          }, null, 8, ["labels", "tooltipLabels", "dataset", "stack", "stackTooltipCumulative", "legendInverseOrder", "tooltipInverseOrder", "height", "formatLabelFunction", "formatValueFunction", "emptyMessage"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_EChartsColumnAndLine, {
              layout: "combined",
              xData: _ctx.getCategoryLabels,
              tooltipLabels: _ctx.getTooltipLabels,
              columnYData: _ctx.getColumnAndLineColumnData,
              columnYName: _ctx.getColumnAndLineColumnName,
              lines: _ctx.getColumnAndLineLines,
              colors: _ctx.getColumnAndLineColors,
              height: _ctx.height,
              marker: _ctx.getColumnAndLineMarker,
              barMaxWidth: 80,
              columnMin: _ctx.min,
              formatYLabelFunction: _ctx.getFormatLabelFunction,
              formatTooltipFunction: _ctx.getFormatValueFunction,
              dataLabels: { enabledOnSeries: [] },
              showYAxis: "",
              sizeXYLabel: _ctx.sizeXYLabel,
              legendTextMaxWidth: 320,
              tooltipMaxWidth: 320,
              emptyMessage: _ctx.getEmptyMessage
            }, null, 8, ["xData", "tooltipLabels", "columnYData", "columnYName", "lines", "colors", "height", "marker", "columnMin", "formatYLabelFunction", "formatTooltipFunction", "sizeXYLabel", "emptyMessage"])
          ]))
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
          _createVNode(_component_Loader)
        ]))
      : _createCommentVNode("", true)
  ]))
}